import ADTEventsDetails from './ADTEventDetails';
import ADTEvents from './ADTEvents';
import ADTLog from './ADTLog';

const stackRoutes = [
  {
    name: 'ADT Logs',
    path: '/adtLogs',
    component: ADTLog,
  },
  {
    name: 'ADT Events',
    path: '/adtLogs/:ADTLogId/adtEvents',
    component: ADTEvents,
    type: 'slider',
    children: [
      {
        name: 'Details ADT Events',
        path: '/adtLogs/:ADTLogId/adtEvents/:ADTEventId',
        component: ADTEventsDetails,
        screenOptions: {
          modalSize: 'medium',
        },
      },
    ],
  },
];

export default {
  stack: stackRoutes,
};
